
 @if (!isGeneric) {
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ applicantText.your }} Details</mat-card-title>
    </mat-card-header>
    <mat-card-content class="m-t-1">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </mat-card-content>
  </mat-card>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}
 

 <ng-template #content>
 
      <app-select-input [label]="applicantText.your + ' Title'" [control]="applicantDetailsForm.controls.title"
        [lookupItems]="titles" shortLabel="Title" placeholder="Select a Title">
      </app-select-input>

    

    @if (applicantDetailsForm.controls.title.value?.value === 'Other') {

      <app-text-input label="Please specify title" [control]="applicantDetailsForm.controls.titleOther" shortLabel="Title">
      </app-text-input>

    }

    <app-text-input [label]="applicantText.your + ' Given Names'" [control]="applicantDetailsForm.controls.firstName" 
    shortLabel="Given Names">
    </app-text-input>

    <app-text-input [label]="applicantText.your + ' Surname / Family Name'"
      shortLabel="Surname"
      [control]="applicantDetailsForm.controls.surname">
    </app-text-input>


   

      <app-date-input [label]="applicantText.your + ' Date of Birth'" [control]="applicantDetailsForm.controls.dob"
        shortLabel="Date of Birth">
      </app-date-input>

    
@if (!isVevoEmployee && !isVevoContract) {

      <app-text-input [label]="applicantText.your + ' Email Address'" [control]="applicantDetailsForm.controls.email"
        shortLabel="Email Address" 
        type="email">
      </app-text-input>
    }
    @if (!isVevoEmployee && !isVevoContract) {

      <app-phone-input label="{{ applicantText.your }} Best Contact Phone Number"
        [phoneTypes]="phoneTypes"
        [phoneTypeControl]="applicantDetailsForm.controls.phoneType"
        [phoneCountryCodeControl]="applicantDetailsForm.controls.phoneCountryCode"
        [phoneAreaCodeControl]="applicantDetailsForm.controls.phoneAreaCode"
        [phoneNumberControl]="applicantDetailsForm.controls.phoneNumber">
      </app-phone-input>

    }

    @if (!isVevo && !isGeneric || (isGeneric && enquiryType != 'other') ) {

      <app-select-input [label]="'What is ' + applicantText.your.toLowerCase() + ' marital status?'"
      shortLabel="Marital Status"
        [control]="applicantDetailsForm.controls.maritalStatus" [lookupItems]="maritalStatus" placeholder="Select a Marital Status">
      </app-select-input>

    }

    @if(!isGeneric || (isGeneric && enquiryType != 'other')){
  
          <app-select-input [label]="applicantText.your + ' Country of Passport'"
            shortLabel="Country of Passport"
            [control]="applicantDetailsForm.controls.passportCountry" [lookupItems]="countries" placeholder="Select a Country">
          </app-select-input>



        <app-text-input [label]="applicantText.your + ' Passport Number'"
          shortLabel="Passport Number"
          [control]="applicantDetailsForm.controls.passportNumber">
        </app-text-input>
    }
    
      @if(!isGeneric || (isGeneric && enquiryType != 'other') || isAddressForced) {
      <app-radio-input
        [label]="isVevoEmployee ? 'Is this person currently located in Australia' : applicantText.areYou + ' currently located in Australia?'"
        shortLabel="In Australia"
        [control]="applicantDetailsForm.controls.inAustralia"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
        [errorMsg]="'Current location is required'">
      </app-radio-input>
      }

    @if (model.applicantDetails?.inAustralia === 'false') {
         <app-address label="Current Residential Address" [isSubmitted]="formSubmitted"
          [addressForm]="applicantDetailsForm.controls.currentResidentialAddress">
        </app-address>
    

      @if (!isGeneric && !isVevo && !isAppealRefuse &&
      !isAppealCancel) {

        <app-select-input [label]="applicantText.your + ' Current Location'"
          shortLabel="Current Location"
          [control]="applicantDetailsForm.controls.location" [lookupItems]="countries" placeholder="Select a Country"
          [errorMsg]="'Current location is required'">
        </app-select-input>

      }
    }

    @if (model.applicantDetails?.inAustralia === 'true') {

    <app-address label="Current Residential Address" [isSubmitted]="formSubmitted"
      [addressForm]="applicantDetailsForm.controls.currentResidentialAddress">
    </app-address>

    @if (!isAppealRefuse && !isAppealCancel &&
    !isVevo) {

        <app-date-input 
          shortLabel="Arrival Date"
          [label]="'What date did ' + applicantText.your.toLowerCase() + ' last arrive in Australia?'"
          [control]="applicantDetailsForm.controls.arriveAustralia">
        </app-date-input>
    

    }
    @if (!isAppealRefuse && !isAppealCancel &&
    !isVevo) {
      
       
        <app-date-input
          shortLabel="Departure Date"
          [label]="'What date are ' + applicantText.you.toLowerCase() + ' required to depart Australia?'"
          [control]="applicantDetailsForm.controls.departAustralia">
        </app-date-input>

      }
      @if (!isAppealCancel && !isVevo) {

        <app-radio-input [label]="applicantText.doYou + ' hold an Australian Visa?'"
          shortLabel="Hold Australian Visa"
          [control]="applicantDetailsForm.controls.holdAustralianVisa"
          [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>

      }


      @if (model.applicantDetails?.holdAustralianVisa === 'true' && !isAppealCancel &&
      !isVevo) {

        <app-select-input [label]="'What visa ' + applicantText.doYou.toLowerCase() + ' currently hold?'"
            shortLabel="Current Visa"
          [control]="applicantDetailsForm.controls.visaType" [visaTypes]="visaTypes" placeholder="Select a Visa Type">
        </app-select-input>

        <app-date-input [label]="'When does ' + applicantText.your.toLowerCase() + ' current visa expire?'"
          shortLabel="Visa Expiry"
          [control]="applicantDetailsForm.controls.visaExpire" >
        </app-date-input>

      }
    }

    @if (isAppealRefuse || isAppealCancel) {

      @if (applicantDetailsForm.controls.maritalStatus.value?.id === 'engaged' || applicantDetailsForm.controls.maritalStatus.value?.id === 'married' ||
      applicantDetailsForm.controls.maritalStatus.value?.id === 'de-facto') {

        <app-radio-input
          [label]="'Is ' + applicantText.your.toLowerCase() + ' spouse/partner an Australian citizen, permanent resident or New Zealand citizen?'"
          [control]="applicantDetailsForm.controls.partnerCitizen"
          shortLabel="Partner Citizen"
          [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>

      }

      <app-radio-input [label]="'Are ' + applicantText.you.toLowerCase() + ' currently in Immigration Detention or Custody?'"
        [control]="applicantDetailsForm.controls.inDetention"
        shortLabel="In Detention"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>

      @if (model.applicantDetails?.inDetention === 'true') {
          <app-text-input 
          shortLabel="Detention Facility Name"
          [label]="'What is the name of the facility where ' + applicantText.you.toLowerCase() + ' are located?'"
            [control]="applicantDetailsForm.controls.detentionFacility">
          </app-text-input>
    
   

      }
    }

    @if (isStudy) {

      <app-radio-input
        [label]="applicantText.haveYou + ' been accepted for full-time study in a registered course or part of a registered course?'"
        shortLabel="Accepted for Study"
        [control]="applicantDetailsForm.controls.acceptedForStudy"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>

      @if (model.applicantDetails?.acceptedForStudy === 'true') {
        
          <app-text-input 
            shortLabel="Course Name"
            [label]="'What is the name of the course ' + applicantText.you.toLowerCase() + ' have been accepted into?'"
            [control]="applicantDetailsForm.controls.nameOfCourse">
          </app-text-input>



        <app-radio-input 
          [label]="applicantText.doYou + ' have confirmation of enrolment?'"
          shortLabel="Confirmation of enrolment"
          [control]="applicantDetailsForm.controls.enrolmentConfirmation"
          [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>

      }
     
        <app-text-area
          shortLabel="Study Reasons"
          [label]="'Please provide an explanation of why ' + applicantText.you.toLowerCase() + ' would like to study in Australia and what ' + applicantText.you.toLowerCase() + ' would like to study'"
          [control]="applicantDetailsForm.controls.studyReasons">
        </app-text-area>



    }


 
 </ng-template>